<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Fecha Despacho"
          label-for="fechaDespacho"
          :labelCols="labelCols">
          <b-input-group>
            <b-form-input 
              id="fechaDespacho" 
              v-model="fechaDespacho" 
              type="date"
              :state="fechaDespachoValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaDespachoFeedback">
            {{ fechaDespachoInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Fecha Entrega"
          label-for="fechaEntregaEstimada"
          description="Fecha de Entrega Estimada"
          :label-cols="labelCols">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox 
                  id="fechaEntregaEstimadaHabilitada"
                  v-model="fechaEntregaEstimadaHabilitada"
                  :value="true"
                  :unchecked-value="false">
              </b-form-checkbox>
            </b-input-group-prepend>
            <b-form-input 
              id="fechaEntregaEstimada" 
              v-model="fechaEntregaEstimada" 
              type="date"
              :disabled="fechaEntregaEstimadaDisabled"
              :state="fechaEntregaEstimadaValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaEntregaEstimadaFeedback">
            {{ fechaEntregaEstimadaInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="actualizarEstado"
              v-model="actualizarEstado"
              :value="true"
              :unchecked-value="false">
              Actualizar Estado (En Camino)
          </b-form-checkbox>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

export default {
  name: 'RemitosActualizacionDespacho',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    remitoId: {
      type: Number,
      default: 0
    },
    remitos: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      fechaDespacho: moment(new Date()).format('YYYY-MM-DD'),
      fechaEntregaEstimada: moment(new Date()).format('YYYY-MM-DD'),
      fechaEntregaEstimadaHabilitada: false,
      fechaEntregaEstimadaDisabled: true,
      actualizarEstado: false,

      fechaDespachoValida: null,
      fechaDespachoInvalidaMsj: '',
      fechaEntregaEstimadaValida: null,
      fechaEntregaEstimadaInvalidaMsj: '',

      labelCols: 3,
    }
  },
  created() {
  },  
  methods: {
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = true;

      if (this.remitoId == 0) {
        let errorRemitos = true;
        if (this.remitos) {
          errorRemitos = this.remitos.length == 0;
        }
        if (errorRemitos) {
          this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de remitos a actualizar'))
          save = false;
        }
      }


      if (save) {
        this.showSpinner();
        let fechaEntregaEstimada = this.fechaEntregaEstimada;
        if (this.fechaEntregaEstimadaDisabled) {
          fechaEntregaEstimada = '1900-01-01';
        }

        let params = {
          remitoId: this.remitoId,
          remitos: this.remitos,
          fechaDespacho: this.fechaDespacho,
          fechaEntregaEstimada,
          actualizarEstado: this.actualizarEstado
        }
        let msj = 'La información del remito se actualizó con éxito';
        if (this.remitoId == 0) {
          msj = 'La información de los remitos seleccionados se actualizó con éxito';
        }
        this.$store.dispatch('remito/actualizarDespacho', params)
          .then(() => this.showModalMsj(msj, this.close.bind(this, true), this.close.bind(this, true), 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },

    cancelar() {
      this.close(false);
    },
    close(actualizado) {
      this.$emit('close', actualizado);
    }
  },
  validations: {
  },  
  watch: {
    'fechaEntregaEstimadaHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaEstimadaDisabled = !(/true/i).test(this.fechaEntregaEstimadaHabilitada);
    },
  }    
}
</script>

<style>
</style>
